function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as t } from "./index.es33.js";
import { clsx as i } from "./index.es105.js";
import { Table as x } from "./index.es192.js";
import e from "./index.es541.js";
var a = {
    left: function left(s) {
      return s > 0;
    },
    right: function right(s, o) {
      return s < o;
    }
  },
  p = function p(_ref) {
    var s = _ref.columns,
      o = _ref.rows,
      r = _ref.isRight,
      n = _ref.scrollPosition,
      m = _ref.maxScrollPosition;
    var l = a[r ? "right" : "left"](n || 0, m || 0);
    return t.jsx("div", {
      className: i(e.fixed, _defineProperty(_defineProperty({}, e.fixedRight, r), e.fixedLeft, !r)),
      children: t.jsx("table", {
        className: i(e.inner, _defineProperty({}, e.innerShadows, l)),
        children: t.jsx(x, {
          columns: s,
          rows: o
        })
      })
    });
  };
export { p as FixedColumns };